import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductSwitchOffer } from "gql/graphql";

export type ProductSwitchState = {
  currentProductName: string | null;
  offers: ProductSwitchOffer[];
  selectedOffer: ProductSwitchOffer | null;
  isInTrialPeriod: boolean;
};

const initialState: ProductSwitchState = {
  currentProductName: null,
  offers: [],
  selectedOffer: null,
  isInTrialPeriod: false,
};

const productSwitchSlice = createSlice({
  name: "productSwitch",
  initialState,
  reducers: {
    setProductSwitchData(
      state,
      action: PayloadAction<Partial<ProductSwitchState>>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearProductSwitchData() {
      return initialState;
    },
  },
});

export const { setProductSwitchData, clearProductSwitchData } =
  productSwitchSlice.actions;

export default productSwitchSlice;
